import { IRuleOptions, IValidationOptions, IValidationRule, RuleName } from "./Validator";

export class CustomRule implements IValidationRule
{
    public rule: RuleName = 'Custom';
    private callback: (value: string) => boolean;
    private errorLabel: string;

    constructor(callback: (value: string) => boolean, validationOptions: IValidationOptions, ruleOptions: IRuleOptions = {})
    {
        this.callback = callback;
        this.errorLabel = ruleOptions.errorLabel ?? validationOptions.invalidFieldLabel;
    }

    public validate(value: string): string
    {
        if (this.callback(value))
        {
            return '';
        }
        return this.errorLabel;
    }
}
